import * as React from "react";
import "./warning-panel.scss";

export const WarningPanel = ({content}) => {
    return (
        <div className="warning-panel">
            <div className="box"
                onClick={
                    () => {
                        if(content.item.selection) {
                            content.cc.selectField(content.item.side, content.item.selection)
                        }
                    }
                }
                xd-qa-type="button"
                xd-qa-name="Warning"
            >
                <div className="icon">
                    <div className="middle">
                        !
                    </div>
                </div>
                <div className="text">
                    <b>WARNING: </b>{content.item.message}
                </div>
            </div>
        </div>
    )
}
